import LoginPage from './components/Login/LoginPage';
import './index.css';

function App() {
  
  return (
  <LoginPage/>
  );
}

export default App;
